import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from 'react-oidc-context';
import ProtectedRoute from "./ProtectedRoute";
import IraiListHospital from "../forms/IraiListHospital";
import { DataProvider } from "./DataContext";
import IraiRegisterForm from "../forms/IraiRegisterForm";
import CurveReportFormWrapper from "../forms/CurveReportFormWrapper";
import LogoutPage from "../forms/LogoutPage";

import { AlertProvider } from "./AlertContext";
import { ToastProvider } from "./ToastContext";

const cognitoAuthConfig = {
  authority: process.env.REACT_APP_COGNITO_AUTHORITY || "https://cognito-idp.ap-northeast-1.amazonaws.com/ap-northeast-1_1rz7rYtqe",
  client_id: process.env.REACT_APP_COGNITO_CLIENT_ID || "6gghtveb1f49aj61fg65rnu4dv",
  redirect_uri: process.env.REACT_APP_COGNITO_REDIRECT_URI || "https://www.gxp21.com",
  response_type: "code",
  scope: "email phone openid profile",
  extraQueryParams: {
    lang: "ja",
  },
  automaticSilentRenew: true,
  silent_redirect_uri: process.env.REACT_APP_COGNITO_SILENT_REDIRECT_URI || "https://www.gxp21.com/iraiList",
};

export const RouterConfig: React.FC = () => {
  return (
    <BrowserRouter>
      <AuthProvider {...cognitoAuthConfig}>
        <AlertProvider>
          <ToastProvider>
            <DataProvider>
              <Routes>
                {/* ルート("/")にアクセスしたら、認証状況を確認してリダイレクト */}
                <Route path="/" element={<ProtectedRoute><IraiListHospital /></ProtectedRoute>} />
                {/* ログアウト後のページ */}
                <Route path="/logout" element={<LogoutPage />} />
                {/* 保護されたルート */}
                <Route path="/iraiList" element={<ProtectedRoute><IraiListHospital /></ProtectedRoute>} />
                <Route path="/newIrai" element={<ProtectedRoute><IraiRegisterForm /></ProtectedRoute>} />
                <Route path="/curveReport/:iraiId" element={<ProtectedRoute><CurveReportFormWrapper /></ProtectedRoute>} />
              </Routes>
            </DataProvider>
          </ToastProvider>
        </AlertProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};